import { httpService } from "../common/HttpService";

class BetHistoryService {

    constructor() { }

    getBetHistoryList(playerId, currentPageNo) {
        return httpService.get(`betslip/history/${playerId}?perPage=5&currentPage=${currentPageNo}`);
    }


}

export const betHistoryService = new BetHistoryService();